import { FetchStatus } from '@server/fetch_status.type';

export const isOrgConnectionError = (fetchStatus?: FetchStatus) =>
  fetchStatus ? [FetchStatus.InvalidCredentials, FetchStatus.Error].includes(fetchStatus) : false;
